'use client';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@ahafood/ui/components/dialog';
import { Sheet, SheetContent, SheetTitle } from '@ahafood/ui/components/sheet';
import { cn } from '@ahm/common-helpers';
import OrderLocationForm from './order-location-form';
import { useIsMobile } from '@/lib/is-mobile/use-is-mobile';

type OrderLocationSheetProps = {
  open?: boolean;
  onOpenChange: (open: boolean) => void;
};

export function OrderLocationSheet({
  open = false,
  onOpenChange,
}: OrderLocationSheetProps) {
  const isMobile = useIsMobile();

  const handleClose = () => {
    onOpenChange(false);
  };

  // Show Dialog for desktop in webstore mode
  if (!isMobile) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-xl max-h-[90vh] overflow-hidden p-0">
          <DialogHeader className="sr-only">
            <DialogTitle>Chọn địa chỉ giao hàng</DialogTitle>
          </DialogHeader>
          <div className="overflow-y-auto max-h-[90vh]">
            <OrderLocationForm handleClose={handleClose} />
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  // Show Sheet for mobile
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className={cn(
          'size-full max-w-lg mx-auto px-0 pb-0 bg-neutral-10 gap-2 flex flex-col w-full',
          '[&>button]:data-[state=open]:hidden',
          'pt-0'
        )}
        side="bottom"
      >
        <SheetTitle className="hidden">Chọn địa chỉ giao hàng</SheetTitle>
        <OrderLocationForm handleClose={handleClose} />
      </SheetContent>
    </Sheet>
  );
}
